import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Services from "./pages/Services/Services";
import ServiceDetail from "./pages/Services/ServiceDetail";
import About from "./pages/About/About";
import Solutions from "./pages/Solutions/Solutions";
import Partenaires from "./pages/Partenaires/Partenaires";
import Contact from "./pages/Contact/Contact";
import Careers from "./pages/Careers/Careers";
import Apply from "./pages/Apply/Apply";
import PublicationList from "./pages/Publications/PublicationList";
import PublicationDetail from "./pages/Publications/PublicationDetail";
import Header from "./components/Header/Header";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          {/* Toutes les pages détails sont maintenant gérées dynamiquement par ServiceDetail */}
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/partenaires" element={<Partenaires />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/publications" element={<PublicationList />} />
          <Route path="/publications/:id" element={<PublicationDetail />} />
          {/* ajoute tes autres routes */}
        </Routes>
      </Router>
      <Footer />
    </>
  );
}

export default App;
